import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from 'src/app/shared/modules/primeng.module';

@Component({
  selector: 'app-terminos-y-condiciones-modal',
  templateUrl: './terminos-y-condiciones-modal.component.html',
  standalone: true,
  styleUrls: ['./terminos-y-condiciones-modal.component.css'],
  imports: [SharedModule]
})
export class TerminosYCondicionesModalComponent {
  @Input() public showTerminosyCondiciones: boolean = false;
  @Input() public showPrivacyPolicy: boolean = false;

  @Output() hideModal = new EventEmitter<boolean>();

  constructor() {}

  public closeModal(): void {
    this.hideModal.emit(false);
  }
}
